import { createContext } from 'react';
import type { CurrentUser, UserRole } from '@/types';

export interface AuthContextValue {
  isAuthenticated: boolean;
  isInitializing: boolean;
  currentUser: CurrentUser | undefined;
  isProfileLoading: boolean;
  profileError: unknown;
  role: UserRole | null;
  login: (identifier: string, password: string) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
